import PropTypes from 'prop-types'

import ConfirmationModal from '../../../../../shared_components/mui_base_components/modals/confirmation_modal/ConfirmationModal'
import Logger from '../../../../../lib/NewLogger'
import {trackAddDeputyEvent} from './addDeputyEventLogger'

const CancelDeputy = ({context, exit, hideWarning}) => {
  const cancelAddDeputy = () => {
    Logger.log({
      name: 'canceled_add_deputy',
      payload: {}
    })

    trackAddDeputyEvent({context, eventName: 'cancel_add_deputy'})

    exit()
    hideWarning()
  }

  return (
    <ConfirmationModal
      bodyText='Changes you made will not be saved.'
      confirmButtonText='Close'
      headingText='Close this window?'
      onClose={hideWarning}
      onConfirmation={cancelAddDeputy}
      open={true}
    />
  )
}

CancelDeputy.propTypes = {
  context: PropTypes.string,
  hideWarning: PropTypes.func,
  exit: PropTypes.func
}

export default CancelDeputy
